import { registerQuery } from 'data-fetching-client';
import appAuthStack from 'hub-http/stacks/hubapi';
import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import * as coreMiddlewares from 'hub-http/middlewares/core';
import { useQuery } from 'data-fetching-client';
const toolAccessClient = promiseClient(createStack(coreMiddlewares.base('tool-access/v1/'), appAuthStack));
export const GET_BREEZE_AGENT_EDIT_ACCESS_REQUEST_STATUS = registerQuery({
  fieldName: 'status',
  args: [],
  fetcher: async () => {
    try {
      const toolAccess = await toolAccessClient.get(`requests/active/breeze-agent-edit`);
      return toolAccess.status;
    } catch (error) {
      console.error('Error fetching tool access request status:', error);
      throw error;
    }
  }
});
export const useGetBreezeAgentEditAccessRequestStatus = () => {
  return useQuery(GET_BREEZE_AGENT_EDIT_ACCESS_REQUEST_STATUS, {});
};